<template>
  <div class="exchanges-connect">
    <div class="exchanges-connect__description">
      <img
          src="@/assets/images/svg/exchange-connection.svg"
          class="exchanges-connect__description__icon"
          alt="exchange connection"
      >
      <h2 class="exchanges-connect__description__title">
        Connect a supported exchanges or trading venue to get started.
      </h2>
      <p class="exchanges-connect__description__subtitle">
        Protos connects seamlessly with top crypto trading venues.
      </p>
    </div>
    <div>
      <BaseButton label="Connect exchange"
                  @click.stop="updateIsConnectExchangesOpen(true)"
      />
    </div>
    <ConnectExchanges
        v-if="isConnectExchangesOpen"
        @close="updateIsConnectExchangesOpen(false)"
     />
  </div>
</template>

<script>
import BaseButton from "@/components/ui/atoms/BaseButton";
import ConnectExchanges from "@/components/ui/shared/modals/connect-exchanges/ConnectExchanges";
export default {
  name: "ExchangesConnect",
  components: { BaseButton, ConnectExchanges },
  data() {
    return {
      isConnectExchangesOpen: false,
    }
  },
  methods: {
    updateIsConnectExchangesOpen(isConnectExchangesOpen) {
      this.isConnectExchangesOpen = isConnectExchangesOpen
    },
  }
}
</script>

<style lang="scss" scoped>
// common
.exchanges-connect {
  display: flex;
  justify-content: space-between;

  &__description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 40rem;

    &__icon {
       height: 5.375rem;
    }

    &__title {
      font-weight: 600;
      text-align: left;
      margin-top: 2.5rem;
    }

    &__subtitle {
      font-weight: 600;
    }

  }

  button {
    width: 10rem;
    font-size: 0.875rem;
    height: 2.5rem;
    line-height: 2.3rem;
    text-align: center;
    margin-bottom: 2.5rem;
  }
}

// only mobile
@media (max-width: 768px) {
  .exchanges-connect {
    flex-direction: column;
    align-items: center;

    &__description {

      &__title {
        font-size: 1.25rem;
      }

      &__subtitle {
        font-size: 0.875rem;
      }

    }
  }
}

// only desktop
@media (min-width: 769px) {
  .exchanges-connect {
    align-items: flex-end;

    &__description {

      &__title {
        font-size: 2rem;
      }

      &__subtitle {
        font-size: 1rem;
      }

    }
  }
}


</style>

